import { render, staticRenderFns } from "./StoreManage.vue?vue&type=template&id=13397704&scoped=true"
import script from "./StoreManage.vue?vue&type=script&lang=js"
export * from "./StoreManage.vue?vue&type=script&lang=js"
import style0 from "./StoreManage.vue?vue&type=style&index=0&id=13397704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13397704",
  null
  
)

export default component.exports